/** @jsx jsx */
import type { Interpolation } from '@emotion/react';
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Grid, breakpoints } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import MultipleStackability from 'bundles/xddp/components/homepage/MultipleStackability';
import SingleStackability from 'bundles/xddp/components/homepage/SingleStackability';
import Container from 'bundles/xddp/components/shared/Container';
import type { UpsellsByDegreeSlug, UserAgentProps } from 'bundles/xddp/types';

import BannerImage from 'images/xddp/stackability-image.png';

const styles: Record<string, Interpolation<Theme>> = {
  root: css`
    padding: 36px 0;
  `,
  imageContainer: () => css`
    padding-left: 24px;
    ${breakpoints.down('sm')} {
      display: none;
    }
  `,
  image: css`
    width: 100%;
  `,
};

type Props = UserAgentProps & {
  stackableItems: UpsellsByDegreeSlug;
};

const StackabilityInfo = ({ stackableItems, userAgent }: Props) => {
  if (!stackableItems?.length) {
    return null;
  }

  return (
    <div css={styles.root} data-testid="stackability-info">
      <Container>
        <Grid container alignItems={stackableItems.length > 1 ? 'flex-start' : 'center'} spacing={24}>
          <Grid item xs={12} lg={6} md={6} sm={12} style={{ zIndex: 2 }}>
            {stackableItems.length === 1 ? (
              <SingleStackability items={stackableItems} userAgent={userAgent} />
            ) : (
              <MultipleStackability items={stackableItems} userAgent={userAgent} />
            )}
          </Grid>
          <Grid item xs={12} lg={6} md={6} sm={12} style={{ zIndex: 1 }}>
            <div css={styles.imageContainer}>
              <Imgix css={styles.image} src={BannerImage} alt="stackability-banner" aria-hidden={true} />
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default StackabilityInfo;
